import React, { Component } from 'react';
import TableContainer from './TableContainer'
import SharingContainer from './SharingContainer'
import ItemView from './itemscreens/ItemView.js'
import Perf from 'react-addons-perf'
window.Perf = Perf

class Menu extends Component{

  constructor(props) {
     super(props);
     this.state = {
       rad1: true,
       rad2: false
     };

   }




  showHide(e){
    this.setState({[e]: !this.state[e]})
  }

  componentWillMount() { // or componentDidMount
  //  fetch(this.props.match.params.id)
  }
  componentDidMount() {

 }

  render(){
//    const tempData = [{id: 1, value: "nodata", active: true, count: 0}]

    return (

      <div>


        <div style={{visibility: this.props.loading?"visible":"hidden"}} className="load-bar">
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

        <div style={{ opacity: this.props.loading ? 0.5 : 1 }}>
        <div className="container-fluid">
        <div style={{marginRight: '-15px', marginLeft: '-15px'}} className="panel panel-default">
        <div className="panel-heading">
          <h3 className="panel-title">Classification, Hands & Seals <a style={{color: '#CC0C00', fontSize: '0.8em'}} onClick={() => this.showHide("rad1")}>{this.state.rad1?"hide":"show"}</a></h3>
        </div>
        <div style={{display: !this.state.rad1?'none':'block'}} className="panel-body">
      <div className="row">

      <div className="col-md-12">
        <div className="col-md-2">
          {this.props.data.collections?<SharingContainer title="Site" name="collections" prefix="c" data={this.props.data.collections}/>:null}
        </div>

        <div className="col-md-2">
          {this.props.data.tables?<TableContainer data={this.props.data.tables}/>:null}
        </div>
        <div className="col-md-1">
          {this.props.data.writers?<SharingContainer title="Hand" name="writers" prefix="w" data={this.props.data.writers}/>:null}
        </div>
        <div className="col-md-1">
          {this.props.data.stylus?<SharingContainer title="Stylus" name="stylus" prefix="st" data={this.props.data.stylus}/>:null}
        </div>

        <div className="col-md-2">
          {this.props.data.series?<SharingContainer title="Series" name="series" prefix="s" data={this.props.data.series}/>:null}
        </div>
        <div className="col-md-1">
          {this.props.data.subseries?<SharingContainer title="Subseries" name="subseries" prefix="ss" data={this.props.data.subseries}/>:null}
        </div>

        <div className="col-md-1">
          {this.props.data.sets?<SharingContainer title="Set" name="sets" prefix="se" data={this.props.data.sets}/>:null}
        </div>
        <div className="col-md-2">
          {this.props.data.seals?<SharingContainer title="Seal" name="seals" prefix="sl" data={this.props.data.seals}/>:null}
        </div>
      </div>
</div>
</div>
    </div>
</div>



{/* rad 2 */}
{this.props.data.chronologies?
<div id="filterpanel-rad2"  className="container-fluid">

  <div style={{marginRight: '-15px', marginLeft: '-15px'}} className="panel panel-default">
    <div className="panel-heading">
      <h3 className="panel-title">Chronological & Spatial data <a style={{color: '#CC0C00', fontSize: '0.8em'}} onClick={() => this.showHide("rad2")}>{this.state.rad2?"hide":"show"}</a></h3>
    </div>
    <div style={{display: !this.state.rad2?'none':'block'}} className="panel-body">
      <div className="row">
        <div className="col-md-12">
  <div className="col-md-2">
    {this.props.data.chronologies?<SharingContainer title="Chronology" name="chronologies" prefix="ch" data={this.props.data.chronologies}/>:null}
  </div>
  <div className="col-md-2">
    {this.props.data.findareas?<SharingContainer title="Find-area" name="findareas" prefix="fa" data={this.props.data.findareas}/>:null}
  </div>
  <div className="col-md-2">
    {this.props.data.findplaces?<SharingContainer title="Find-spot" name="findplaces" prefix="fp" data={this.props.data.findplaces}/>:null}
  </div>
  <div className="col-md-2">
    {this.props.data.proveniences?<SharingContainer title="Provenance" name="proveniences" prefix="p" data={this.props.data.proveniences}/>:null}
  </div>
  <div className="col-md-1">
    {this.props.data.years?<SharingContainer title="Find year" name="years" prefix="y" data={this.props.data.years} />:null}
  </div>
  <div className="col-md-1">
    {this.props.data.locations?<SharingContainer  title="Location" name="locations" prefix="l" data={this.props.data.locations}/>:null}
  </div>
  <div className="col-md-2">
    {this.props.data.invnos?<SharingContainer title="Inv. No." name="invnos" prefix="i" data={this.props.data.invnos}/>:null}
  </div>
</div>
</div>
</div>
</div>

</div>
:null}


{/* rad 3
<div id="filterpanel-rad3" className="container-fluid">
  <div className="panel panel-default">
    <div className="panel-heading">
      <h3 className="panel-title">People</h3>
    </div>
    <div className="panel-body">
      <div className="row">
        <div className="col-md-12">
  <div className="col-md-2">
    {tempData?<SharingContainer title="Person(s)" data={tempData}/>:null}
  </div>
  <div className="col-md-2">
    {tempData?<SharingContainer title="Probability" data={tempData}/>:null}
  </div>
  <div className="col-md-2">
    {tempData?<SharingContainer title="Occurrence" data={tempData}/>:null}
  </div>
  <div className="col-md-2">
    {tempData?<SharingContainer title="Gender" data={tempData} />:null}
  </div>
  <div className="col-md-2">
    {tempData?<SharingContainer title="Role" data={tempData}/>:null}
  </div>
  <div className="col-md-2">
    {tempData?<SharingContainer title="LGr. Name" data={tempData}/>:null}
  </div>
</div>
</div>
</div>
</div>
</div>




{/* rad 4

<div id="filterpanel-rad4" className="container-fluid">

    <div className="panel panel-default">
      <div className="panel-heading">
        <h3 className="panel-title">Places</h3>
      </div>
      <div className="panel-body">
        <div className="row">
          <div className="col-md-12">


  <div className="col-md-4">
    {tempData?<SharingContainer title="Place" data={tempData}/>:null}
  </div>
  <div className="col-md-4">
    {tempData?<SharingContainer title="Region" data={tempData}/>:null}
  </div>
  <div className="col-md-4">
    {tempData?<SharingContainer title="Probability" data={tempData}/>:null}
  </div>
</div>
</div>
</div>
</div>
</div>
*/}



<div className="container">


      {this.props.data.tables?<ItemView history={this.props.history} data={this.props.data.tables}/>:null}

</div>




</div>

    </div>
    )
  }
}

 export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js